import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated'
import { getModalLocation } from '../../../../lib/modal'

import NeonLogo from '../../../../../images/neon/neon-logo-yellow.svg'
import NavLinkWithQuery from '../../../../components/shared/nav-link-with-query'
import Button from '../../../../components/button'
import styles from './header.css'

/**
 * Renders a header with a neon logo and optional ogin button
 */
const Header = () => {
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()

  return (
    <div className={styles.header}>
      <NavLink to="/">
        <img src={NeonLogo} alt="Neon Logo" className={styles.logo} />
      </NavLink>

      {!isAuthenticated && (
        <>
          <NavLinkWithQuery
            exact
            to={getModalLocation(location, 'login')}
            analyticsLabel="login"
            className={styles.navLink}
          >
            <Button
              text="log in"
              wrapperClassName={styles.linkButtonFrame}
              className={styles.linkButton}
              darkBGSecondary
            />
          </NavLinkWithQuery>
        </>
      )}
    </div>
  )
}

export default Header
